import { create } from "zustand";
import { defFilters } from "constants/filters";
import { centerLat, centerLng, point1Lat, point1Lng, point2Lat, point2Lng, zoom } from "constants/map";

const parseBoolean = (value) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (normalized === "true") return true;
    if (normalized === "false" || normalized === "") return false;
  }
  return Boolean(value);
};

const defaultMapBounds = {
  point1Lat,
  point1Long: point1Lng,
  point2Lat,
  point2Long: point2Lng,
};

const defaultMapCanter = {
  mapCanterLat: centerLat,
  mapCanterLng: centerLng,
  zoom,
};

export const useOrdersMapStore = create((set) => ({
  selectedShipmentIds: [],
  // Snapshot of the full shipment object for each selected id, so the
  // "Selected Orders" pane survives viewport refetches (panning the map).
  selectedShipmentsById: {},
  selectedDriverId: null,
  productFilters: defFilters,
  mapBounds: defaultMapBounds,
  mapCanter: defaultMapCanter,
  shipmentSearchText: "",
  driverSearchText: "",
  onlyScheduledOrders: false,
  setSelectedShipmentIds: (value) =>
    set((state) => ({
      selectedShipmentIds:
        typeof value === "function" ? value(state.selectedShipmentIds) : value,
    })),
  // Rebuild the snapshot cache from the currently-selected ids: take fresh data
  // from the in-view shipments when present, otherwise keep the last-known
  // snapshot. Ids no longer selected fall out (pruned) since we rebuild.
  syncSelectedSnapshots: (shipments, selectedIds) =>
    set((state) => {
      const inView = new Map(
        (shipments || []).map((s) => [String(s?.id), s])
      );
      const next = {};
      for (const id of selectedIds || []) {
        const key = String(id);
        next[key] = inView.get(key) ?? state.selectedShipmentsById[key];
      }
      return { selectedShipmentsById: next };
    }),
  setSelectedDriverId: (value) =>
    set((state) => ({
      selectedDriverId:
        typeof value === "function" ? value(state.selectedDriverId) : value,
    })),
  setProductFilters: (value) =>
    set((state) => ({
      productFilters:
        typeof value === "function" ? value(state.productFilters) : value,
    })),
  setMapBounds: (value) =>
    set((state) => ({
      mapBounds: typeof value === "function" ? value(state.mapBounds) : value,
    })),
  setMapCanter: (value) =>
    set((state) => ({
      mapCanter: typeof value === "function" ? value(state.mapCanter) : value,
    })),
  setShipmentSearchText: (value) =>
    set((state) => ({
      shipmentSearchText:
        typeof value === "function" ? value(state.shipmentSearchText) : value,
    })),
  setDriverSearchText: (value) =>
    set((state) => ({
      driverSearchText:
        typeof value === "function" ? value(state.driverSearchText) : value,
    })),
  setOnlyScheduledOrders: (value) =>
    set((state) => ({
      onlyScheduledOrders: parseBoolean(
        typeof value === "function" ? value(state.onlyScheduledOrders) : value
      ),
    })),
}));
